/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValidatePalNpiResponse } from './ValidatePalNpiResponse';
import {
    ValidatePalNpiResponseFromJSON,
    ValidatePalNpiResponseFromJSONTyped,
    ValidatePalNpiResponseToJSON,
} from './ValidatePalNpiResponse';

/**
 * 
 * @export
 * @interface ValidatePalNpi200Response
 */
export interface ValidatePalNpi200Response {
    /**
     * 
     * @type {ValidatePalNpiResponse}
     * @memberof ValidatePalNpi200Response
     */
    data?: ValidatePalNpiResponse;
}

/**
 * Check if a given object implements the ValidatePalNpi200Response interface.
 */
export function instanceOfValidatePalNpi200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ValidatePalNpi200ResponseFromJSON(json: any): ValidatePalNpi200Response {
    return ValidatePalNpi200ResponseFromJSONTyped(json, false);
}

export function ValidatePalNpi200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpi200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ValidatePalNpiResponseFromJSON(json['data']),
    };
}

export function ValidatePalNpi200ResponseToJSON(value?: ValidatePalNpi200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ValidatePalNpiResponseToJSON(value.data),
    };
}

